const mEditionMapChartPoints = {
  mEditionMapChartPoints: {

    messageAlertFamily: {
      firstText: 'Aún no tienes integrantes para el equipo',
      secondText: 'Para agregar integrantes puedes acceder en Equipos'
    },

    messageAlertTeam: {
      firstText: 'Aún no tienes equipos creados. Para crear equipos puedes acceder a Equipos haciendo',
      secondText: 'click aquí. '
    },

    messageAlertNoTeam: {
      firstText: 'No tienes alumnos sin equipos'
    },

    messageLoading: {
      firstText: 'Cargando..'
    },

    select: {
      equipo: 'Todos los equipos'
    }
  }
}

export default mEditionMapChartPoints
